// extracted by mini-css-extract-plugin
export var fileUpload = "_ed-1";
export var modalButton = "_ed-0";